import { useState, useEffect } from "react";
import EXIF from "exif-js";

// Convert [deg, min, sec] into a decimal degree
function toDecimal(coord) {
    if (!coord || coord.length !== 3) return null;
    return coord[0] + coord[1] / 60 + coord[2] / 3600;
}

export function useExif(imageUrl) {
    const [location, setLocation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!imageUrl) return;

        setLoading(true);
        setError(null);

        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = imageUrl;

        img.onload = () => {
            try {
                EXIF.getData(img, function () {
                    const lat = toDecimal(EXIF.getTag(this, "GPSLatitude"));
                    const latRef = EXIF.getTag(this, "GPSLatitudeRef");
                    const lng = toDecimal(EXIF.getTag(this, "GPSLongitude"));
                    const lngRef = EXIF.getTag(this, "GPSLongitudeRef");

                    if (
                        typeof lat === "number" &&
                        typeof lng === "number" &&
                        typeof latRef === "string" &&
                        typeof lngRef === "string"
                    ) {
                        const latitude = lat * (latRef === "S" ? -1 : 1);
                        const longitude = lng * (lngRef === "W" ? -1 : 1);

                        setLocation({ latitude, longitude });
                    } else {
                        setLocation(null);
                    }
                    setLoading(false);
                });
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        img.onerror = () => {
            setError("Failed to load image");
            setLoading(false);
        };
    }, [imageUrl]);

    return { location, loading, error };
}
